import TokenEditor from "./TokenEditor";
import { EditorMode } from "shared/enums/EditorModeEnum";
import SubscriptionTokenResponse from "interfaces/response/SubscriptionTokenResponse";
import TokenEditorModal from "./TokenEditorModal";

interface Props {
  onClose?: () => void;
  token?: SubscriptionTokenResponse | null;
}

export default function EditTokenPopup(props: Props) {
  const { onClose, token } = props;
  return (
    <TokenEditorModal title="Edit Token" onClose={() => onClose?.()}>
      <TokenEditor
        mode={EditorMode.Edit}
        token={token}
        onCancel={() => onClose?.()}
      />
    </TokenEditorModal>
  );
}
